module.exports = __webpack_public_path__ + "img/menu_background.8ec1f184.png";